import {useLocation, useNavigate} from '@tanstack/react-router'
import {useCallback} from 'react'

export function useNavigateBackToTradeNameForm() {
  const location = useLocation()
  const navigate = useNavigate()

  return useCallback(async () => {
    if (location.state.navigate?.to !== '/configuration/products/trade-names/new') return false

    window.scrollTo({top: 0, left: 0, behavior: 'auto'})
    await navigate({...location.state.navigate, ignoreBlocker: true})

    return true
  }, [location.state.navigate, navigate])
}
